/* Rquiere de mixin.js */

var store = {
	data () {
		return {
			listStoreRacks: [],
			methodsStoreRack: {
				create: 'register',
				get: 'storeRacks',
				show: 'storeRack/',
			},
            objectStoreRack: {
                exist: 0,
                id: 0,
                name: '',
                color: '',
                store_id: 0,
                store: {},
                created_at: '',
                updated_at: ''
            },
			paginationStoreRacks: [],
            searchStoreRack: '',
            searchingStoreRack: false,
            storeRackIdSelected: 0
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        clearObjectStoreRack() {
            this.objectStoreRack.exist = 0
            this.objectStoreRack.id = 0
            this.objectStoreRack.name = ''
            this.objectStoreRack.color = ''
            this.objectStoreRack.store_id = 0
            this.objectStoreRack.store = {}
            this.objectStoreRack.created_at = ''
            this.objectStoreRack.updated_at = ''
        },
        getAllStoreRacks(page = 1) {
            this.searchingStoreRack = true
            this.listStoreRacks = []
            let url = this.getApiBackend + this.methodsStoreRack.get
            this.axiosActionIS(url, 'GET', 'getAllStoreRacksResult')
        },
        getAllStoreRacksResult(response) {
            this.searchingStoreRack = false
            if(response.data.success == true) {
                this.listStoreRacks = response.data.data
                this.paginationStoreRacks = response.data.paginate
            }
            this.getAllStoreRacksResultLocal(response)
        },
        getAllStoreRacksResultLocal(response) {
            console.log('getAllStoreRacksResultLocal no desarrollado', response)
        },
        getStoreRacksByStoreId(storeId) {
            this.searchingStoreRack = true
            this.listStoreRacks = []
            let url = this.getApiBackend + 'store/' + storeId + '/' + this.methodsStoreRack.get
            this.axiosActionIS(url, 'GET', 'getStoreRacksByStoreIdResult')
        },
        getStoreRacksByStoreIdResult(response) {
            this.searchingStoreRack = false
            if(response.data.success == true) {
                this.listStoreRacks = response.data.data
            }
            this.getStoreRacksByStoreIdResultLocal(response)
        },
        getStoreRacksByStoreIdResultLocal(response) {
            console.log('getStoreRacksByStoreResultLocal no desarrollado', response)
        },
        saveStoreRack(item) {
            let url = this.getApiBackend + this.methodsStoreRack.show + this.methodsStoreRack.create
            this.axiosActionIS(url, 'POST', 'saveStoreRackResult', item)
        },
        saveStoreRackResult(response) {
            this.saveStoreRackResultLocal(response)
        },
        saveStoreRackResultLocal(response) {
            console.log('saveStoreRackResultLocal no desarrollado', response)
        },
	},
};

export default store;